/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Pc_Online_About_P1Inputs */

const en_pc_online_about_p1 = /** @type {(inputs: Pc_Online_About_P1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PdfCraft Online is PDFCraftTool.org's hosted copy of the unmodified web build that ArtCraft publishes with each release (pdfcraft-web-${i?.version}.zip at github.com/storytold/pdfcraft/releases). It is the same Rust code as the desktop app compiled to WebAssembly, so it works the same on Windows, macOS, Linux and ChromeOS, and nothing is installed.`)
};

const zh_pc_online_about_p1 = /** @type {(inputs: Pc_Online_About_P1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`PdfCraft 在线版是 PDFCraftTool.org 托管的一份未经修改的网页版副本，来源是 ArtCraft 随每次发布提供的 pdfcraft-web-${i?.version}.zip（位于 github.com/storytold/pdfcraft/releases）。它与桌面版是同一套 Rust 代码，编译为 WebAssembly，因此在 Windows、macOS、Linux 和 ChromeOS 上体验一致，也无需安装任何东西。`)
};

/**
* | output |
* | --- |
* | "PdfCraft Online is PDFCraftTool.org's hosted copy of the unmodified web build that ArtCraft publishes with each release (pdfcraft-web-{version}.zip at github..." |
*
* @param {Pc_Online_About_P1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_about_p1 = /** @type {((inputs: Pc_Online_About_P1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_About_P1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_about_p1(inputs)
	return zh_pc_online_about_p1(inputs)
});
export { pc_online_about_p1 as "pc.online.about_p1" }